import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { Flash } from './types';

export function useFlash(): Flash {
  const location = useLocation();

  const flash: Flash = useMemo(() => {
    return location.state?.flash ?? {};
  }, [location.state]);

  return flash;
}
